
/**
 * 地图导航按钮（纯前端 · Layer 0）
 *
 * 职责单一：address(+坐标) → NavigationAdapter 生成 URI，点击交给设备地图能力。
 * 策略在 services/map/navigation.js：Android geo:（系统选择器，装哪家用哪家）、
 * iOS 系统地图、PC 网页地图。本组件不含任何厂商 API / SDK / Key。
 *
 * 不做的事：获取定位 / 请求后端 / geocode / 修改订单数据 / 站内导航 / 配送轨迹。
 *
 * 为什么用 <a href> 而非 window.open：移动端浏览器对超链接的 scheme 拉起最可靠。
 * 平台无法处理（如 Android 没装任何地图 App）时点击无反应——地址文本由页面层
 * 展示兜底（地址为主，本按钮只是增强），不做 App 检测大全。
 *
 * 有坐标优先精准点（GCJ-02 legacy，坐标系换算与参数顺序由 Adapter 吸收）；
 * 无坐标走关键字搜索。地址来源必须是订单快照（order.contact_address），
 * 严禁回查用户当前地址——历史订单用下单时冻结的地址。
 */
import { buildNavigationUri } from '@/services/map/navigation'

export default {
  name: 'MapNavButton',
  props: {
    address: { type: String, default: '' },
    latitude: { type: [Number, String], default: null },
    longitude: { type: [Number, String], default: null }
  },
  computed: {
    hasAddress () {
      return !!(this.address && String(this.address).trim())
    },
    mapUrl () {
      // coordinateSystem 缺省走 Adapter 的 legacy 默认（GCJ-02，历史坐标同源）
      return buildNavigationUri({
        address: this.address,
        latitude: this.latitude,
        longitude: this.longitude
      })
    }
  }
}
